<!-- Change only the identified area for routes -->

<template>
  <div v-if="showNavbar">
    <nav class="navbar navbar-expand-sm navbar-light bg-white border-bottom">
      <div class="container-fluid">
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbar"
          aria-controls="navbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbar">
          <div class="navbar-nav">
            <!-- Begin Edit Area - Add or update links -->
            <!-- use the named route pattern -->
            <RouterLink :to="{ name: 'ReferenceData' }" class="nav-link me-3"
              >Reference Data</RouterLink
            >
            <RouterLink :to="{ name: 'Admin' }" v-if="isAdmin" class="nav-link"
              >Admin</RouterLink
            >
            <RouterLink
              :to="{ name: 'Game', params: { environment: 'wetland' } }"
              class="nav-link"
              >Wetland</RouterLink
            >
            <RouterLink
              :to="{ name: 'Game', params: { environment: 'forest' } }"
              class="nav-link"
              >Forest</RouterLink
            >
            <!-- End Edit Area -->
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
/* Change only the identified area for routes */

import { mapGetters } from "vuex";

export default {
  name: "Navbar",
  computed: {
    ...mapGetters(["showNavbar", "isAdmin"])
  }
};
</script>
